/**
 * Trigger a browser download of a CSV string as a file.
 *
 * A UTF-8 BOM is prepended so Excel opens the file with the correct encoding and
 * renders accented characters instead of mojibake. Mirrors the Blob + object-URL
 * pattern used elsewhere in the app (e.g. the scheduler ExportModal).
 */
const UTF8_BOM = String.fromCharCode(0xfeff);

export function downloadCsv(filename: string, csv: string): void {
  const blob = new Blob([UTF8_BOM + csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}

export default downloadCsv;
